import {
  FormControl,
  FormControlLabel,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  Stack,
  Switch,
  TextField,
  Typography,
} from '@mui/material';
import { FormsErrorDataType } from 'containers/dashboard/Forms/FormListingType';
import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  allowTransactionCost: boolean;
  transactionAmount: number;
  transactionCostType: string;
  transactionUnitAmount: number;
  transactionCostVariableBaseAmount: number;
  transactionCostLabel: string;
  onChangeMode: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onChangeElement: (
    e:
      | React.ChangeEvent<
          HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
        >
      | SelectChangeEvent
  ) => void;
  stateError: FormsErrorDataType;
};

const TransactionCostSettings: FunctionComponent<Props> = ({
  transactionUnitAmount,
  transactionCostVariableBaseAmount,
  allowTransactionCost,
  transactionAmount,
  transactionCostType,
  transactionCostLabel,
  onChangeMode,
  stateError,
  onChangeElement,
}) => {
  const { t } = useTranslation();

  return (
    <Stack direction='column' spacing='30px'>
      <FormControlLabel
        control={
          <Switch
            name='allowTransactionCost'
            checked={allowTransactionCost}
            onChange={onChangeMode}
          />
        }
        label={t('add_transaction_cost')}
      />

      {allowTransactionCost ? (
        <>
          <TextField
            id='outlined-basic'
            name='transactionCostLabel'
            label={t('transaction_cost_label')}
            variant='outlined'
            type='string'
            value={transactionCostLabel}
            onChange={onChangeElement}
            error={stateError.transactionCostLabel.length ? true : false}
            helperText={stateError.transactionCostLabel}
          />
          <FormControl fullWidth>
            <InputLabel id='demo-simple-select-label'>
              {t('transaction_cost_type')}
            </InputLabel>

            <Select
              name='transactionCostType'
              labelId='demo-simple-select-label'
              id='demo-simple-select'
              value={transactionCostType}
              label={t('transaction_cost_type')}
              onChange={onChangeElement}
            >
              <MenuItem value='fixed'> {t('fixed')}</MenuItem>
              <MenuItem value='variable'> {t('variable')}</MenuItem>
            </Select>
          </FormControl>
          {transactionCostType === 'fixed' ? (
            <TextField
              id='outlined-basic'
              name='transactionAmount'
              label={t('transaction_amount')}
              variant='outlined'
              type='number'
              value={transactionAmount}
              onChange={onChangeElement}
              error={stateError.transactionAmount.length ? true : false}
              helperText={stateError.transactionAmount}
            />
          ) : (
            <>
              <TextField
                id='outlined-basic'
                name='transactionUnitAmount'
                label={t('unit_amount')}
                variant='outlined'
                type='number'
                value={transactionUnitAmount}
                onChange={onChangeElement}
                error={stateError.transactionUnitAmount.length ? true : false}
                helperText={stateError.transactionUnitAmount}
              />
              <TextField
                id='outlined-basic'
                name='transactionCostVariableBaseAmount'
                label={t('charge') + ' ' + t('per') + ' ' + t('unit_amount')}
                variant='outlined'
                type='number'
                value={transactionCostVariableBaseAmount}
                onChange={onChangeElement}
                error={
                  stateError.transactionCostVariableBaseAmount.length
                    ? true
                    : false
                }
                helperText={stateError.transactionCostVariableBaseAmount}
              />
              <Typography typography='caption'>
                *{t('for_every')}{' '}
                {transactionUnitAmount
                  ? transactionUnitAmount + ' ' + t('bucks')
                  : t('base_amount')}
                {', '}
                {transactionCostVariableBaseAmount
                  ? transactionCostVariableBaseAmount + ' ' + t('bucks')
                  : t('charge') + ' ' + t('per') + ' ' + t('unit_amount')}{' '}
                {t('will_be_charged')}
              </Typography>
            </>
          )}
        </>
      ) : null}

      <Stack direction='row' spacing='10px'>
        {true && (
          <FormHelperText error={true}>{stateError.paymentType}</FormHelperText>
        )}
      </Stack>
    </Stack>
  );
};

export default React.memo(TransactionCostSettings);
